// extracted by mini-css-extract-plugin
export default {"parent":"Parentcontainer_parent__MAJ6Y"};